/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1IndividualpaymentEditorsDiscountTypesQueryResponse,
  GetApiV1IndividualpaymentEditorsDiscountTypesQueryParams,
  GetApiV1IndividualpaymentEditorsDiscountTypes401,
  GetApiV1IndividualpaymentEditorsDiscountTypes500,
} from "../../types/individualPaymentEditorsController/GetApiV1IndividualpaymentEditorsDiscountTypes.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1IndividualpaymentEditorsDiscountTypes } from "../../clients/individualPaymentEditorsController/getApiV1IndividualpaymentEditorsDiscountTypes.ts";

export const getApiV1IndividualpaymentEditorsDiscountTypesQueryKey = (
  params?: GetApiV1IndividualpaymentEditorsDiscountTypesQueryParams,
) =>
  [
    { url: "/api/v1/individualpayment/editors/discount-types" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1IndividualpaymentEditorsDiscountTypesQueryKey = ReturnType<
  typeof getApiV1IndividualpaymentEditorsDiscountTypesQueryKey
>;

export function getApiV1IndividualpaymentEditorsDiscountTypesQueryOptions(
  params?: GetApiV1IndividualpaymentEditorsDiscountTypesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1IndividualpaymentEditorsDiscountTypesQueryKey(params);
  return queryOptions<
    GetApiV1IndividualpaymentEditorsDiscountTypesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsDiscountTypes401
      | GetApiV1IndividualpaymentEditorsDiscountTypes500
    >,
    GetApiV1IndividualpaymentEditorsDiscountTypesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1IndividualpaymentEditorsDiscountTypes(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna os tipos ativos com descrição por idioma e o indicador de empresa associada obrigatória. Migrado do legado RegistryAsync/GetDiscountTypes. **(Requer Authorization para autenticação)**
 * @summary Tipos de desconto ativos para o editor do plano (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/editors/discount-types}
 */
export function useGetApiV1IndividualpaymentEditorsDiscountTypes<
  TData = GetApiV1IndividualpaymentEditorsDiscountTypesQueryResponse,
  TQueryData = GetApiV1IndividualpaymentEditorsDiscountTypesQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1IndividualpaymentEditorsDiscountTypesQueryKey,
>(
  params?: GetApiV1IndividualpaymentEditorsDiscountTypesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1IndividualpaymentEditorsDiscountTypesQueryResponse,
        ResponseErrorConfig<
          | GetApiV1IndividualpaymentEditorsDiscountTypes401
          | GetApiV1IndividualpaymentEditorsDiscountTypes500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1IndividualpaymentEditorsDiscountTypesQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1IndividualpaymentEditorsDiscountTypesQueryOptions(
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentEditorsDiscountTypes401
      | GetApiV1IndividualpaymentEditorsDiscountTypes500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
